import { useEffect, useState } from 'react';
import { DashboardPage } from './pages/Dashboard/DashboardPage';
import { LoginPage } from './pages/Login/LoginPage';
import { CallbackPage } from './pages/Callback/CallbackPage';
import { ReportsPage } from './pages/Reports/ReportsPage';
import { NetworkPage } from './pages/Network/NetworkPage';
import { CostsPage } from './pages/Costs/CostsPage';
import { isAuthenticated } from './services/auth';
import { Spinner } from './components/UI';

type Route = '/' | '/callback' | '/reports' | '/network' | '/costs';

function getRoute(): Route {
  const path = window.location.pathname;
  if (path === '/callback') return '/callback';
  if (path === '/reports') return '/reports';
  if (path === '/network') return '/network';
  if (path === '/costs') return '/costs';
  return '/';
}

function App() {
  const [route, setRoute] = useState<Route>(getRoute());
  const [authChecked, setAuthChecked] = useState(false);
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    setAuthenticated(isAuthenticated());
    setAuthChecked(true);

    // Simple client-side routing via popstate
    const handlePopState = () => {
      setRoute(getRoute());
    };
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  // Navigate helper
  const navigate = (path: Route) => {
    window.history.pushState({}, '', path);
    setRoute(path);
  };

  if (!authChecked) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <Spinner size="lg" />
      </div>
    );
  }

  // OAuth callback route — always accessible
  if (route === '/callback') {
    return <CallbackPage />;
  }

  // Not authenticated — show login
  if (!authenticated) {
    return <LoginPage />;
  }

  // Authenticated routes
  if (route === '/reports') {
    return <ReportsPage onNavigate={navigate} />;
  }

  if (route === '/network') {
    return <NetworkPage onNavigate={navigate} />;
  }

  if (route === '/costs') {
    return <CostsPage onNavigate={navigate} />;
  }

  return <DashboardPage onNavigate={navigate} />;
}

export default App;
